<template>
  <div class="video-screen">
    <!--
      活动时间:
      活动未开始
      活动正在进行 1.推流   2.未推流
      活动已结束
      1.没有推流
        1.1 活动时间
          活动未开始
          活动正在进行
          活动已结束
          可聊天弹幕
      2.有推流
        2.1正常播放
           2.1.1画面关闭
                无聊天弹幕
        2.2观看视频
           聊天弹幕
     -->
    <!-- 没有推流 -->
    <div class="has-url" v-if="video.urlList.length !== 0" @click="showControlBar">
      <div class="top-mask" v-if="!video.showMainScreen">
        <span class="ab-center">画面已关闭</span>
      </div>
      <div
        v-if="!video.liveisPlaying && video.isLive && video.showMainScreen"
        @click="videoStart2Play"
        class="control-play"
      >
        <i class="iconfont icon-video"></i>
      </div>
      <div v-else>
        <transition name="van-fade">
          <div class="video-control-bar" v-show="controlBarShow">
            <i v-if="!isFullScreen" @click="handleShowVideoPanel" class="iconfont icon-setup"></i>
            <i v-if="!isFullScreen" @click="testFull" class="iconfont iconquanping1"></i>
            <i v-else @click="testFull" class="iconfont iconquanping"></i>
          </div>
        </transition>
      </div>
    </div>
    <div class="no-url" v-else>
      <div class="backAttr" v-if="eventLiveBackAttr">
        <img :src="$isCdn(eventLiveBackAttr.eventAttrPath)" alt="" />
        <div class="back_txt">
          <div class="back_label_txt">{{ liveStatusLabel }}</div>
          <div @click="previewVideo" v-if="videoList.length > 0" class="back_video_txt">
            <i class="iconfont iconshipin_"></i>
            <span>观看录像</span>
          </div>
        </div>
      </div>
      <div v-else class="txt">
        <p>{{ liveStatusLabel }}</p>
        <div class="prview-btn">
          <van-button @click="previewVideo"  type="info" block>观看录像</van-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    video() {
      return this.$store.state.activePlay.video
    },
    videoList() {
      return this.activeInfo && this.activeInfo.videoList
    },
    activeInfo() {
      return this.$store.state.activePlay.activeInfo
    },
    eventLiveBackAttr() {
      return this.activeInfo && this.activeInfo.eventLiveBackAttr
    },
    isFullScreen() {
      return this.$store.state.activePlay.isFullScreen
    }
  },
  data() {
    return {
      liveStatusLabel: '',
      controlBarShow: false,
      isPlayIng: false
    }
  },
  watch: {
    activeInfo: {
      handler(val) {
        if (val && val.eventInfo) {
          this.genateLiveTime(val.eventInfo)
        }
      },
      immediate: true
    }
  },
  methods: {
    testFull() {
      const mainPlayerContainer = document.getElementById('videoContainer')
      const w = document.documentElement.clientWidth || document.body.clientWidth
      const h = document.documentElement.clientHeight || document.body.clientHeight
      const cha = Math.abs(h - w) / 2
      if (!mainPlayerContainer) return
      if (!this.isFullScreen) {
        mainPlayerContainer.style.width = h + 'px'
        mainPlayerContainer.style.height = w + 'px'
        mainPlayerContainer.style.zIndex = '98'
        mainPlayerContainer.style.transform = 'translate(-' + cha + 'px,' + cha + 'px) rotate(90deg)'
      } else {
        mainPlayerContainer.style.width = ''
        mainPlayerContainer.style.height = ''
        mainPlayerContainer.style.zIndex = ''
        mainPlayerContainer.style.transform = ''
      }
      this.$store.commit('toggleFullScreen')
      this.$emit('restScreen', this.isFullScreen)
    },
    full() {
      const videoContainer = document.querySelector('.video-container')
      const clientWidth = document.body.clientWidth
      const originW = clientWidth / 2 + 'px'
      videoContainer.style.position = 'absolute'
      videoContainer.style.width = document.body.clientHeight + 'px'
      videoContainer.style.height = document.body.clientWidth + 'px'
      videoContainer.style.transform = 'rotate(90deg)'
      videoContainer.style.zIndex = '100'
      videoContainer.style.transformOrigin = `${originW} center`
    },
    handle2FullScreen() {
      /* bilibili 全屏 */
      // this.$store.commit('controlVideo', {isFullScreen: !this.video.isFullScreen})
      // this.$nextTick(() => {
      //   this.$emit('restScreen')
      // })
      /* 系统全屏 */
      const ele = document.getElementById('mainVideoElement')
      if (ele.requestFullscreen) {
        ele.requestFullscreen()
      } else if (ele.mozRequestFullScreen) {
        ele.mozRequestFullScreen()
      } else if (ele.webkitRequestFullScreen) {
        ele.webkitRequestFullScreen()
      } else if (ele.webkitEnterFullScreen) {
        ele.webkitEnterFullScreen()
      }
    },
    showControlBar() {
      this.controlBarShow = true
      this.set3sHide()
    },
    set3sHide() {
      clearTimeout(this.timer)
      this.timer = setTimeout(() => {
        this.controlBarShow = false
      }, 3000)
    },
    /* 显示视频设置 */
    handleShowVideoPanel() {
      this.$store.commit('controlPanel', {showVideoSet: true})
    },
    videoStart2Play() {
      this.isPlayIng = true
      this.$emit('startPlay')
    },
    genateLiveTime({eventStartTime, eventEndTime}) {
      const now = +new Date()
      if (now < eventStartTime) {
        this.liveStatusLabel = '直播未开始'
      } else if (now > eventEndTime) {
        this.liveStatusLabel = '直播已结束'
      } else {
        this.liveStatusLabel = '直播正在进行中  暂时没有接收到视频信号'
      }
    },
    previewVideo() {
      this.$emit('previewVideofirst')
    }
    // countDown(startTime, endTime) {
    //   const days = (endTime - startTime) / 1000 / 3600 / 24
    //   const day = Math.floor(days)
    //   const hours = (days - day) * 24
    //   const hour = Math.floor(hours)
    //   const minutes = (hours - hour) * 60
    //   const minute = Math.floor(minutes)
    //   const seconds = (minutes - minute) * 60
    //   const second = Math.floor(seconds)
    //   let str = ''
    //   if (day >= 1) {
    //     str = `将于 ${day}天${hour}小时${minute}分钟后 开播`
    //   } else if (day < 1 && day >= 0 && hour >= 1) {
    //     str = `将于 ${hour}小时${minute}分钟后 开播`
    //   } else if (hour < 1 && minute >= 1) {
    //     str = `将于 ${minute}分钟后 开播`
    //   } else if (minute < 1 && second >= 1) {
    //     str = '直播马上开始了'
    //   } else {
    //     str = ''
    //   }
    //   this.countDownText = str
    // }
  }
}
</script>

<style scoped lang="scss">
.video-screen {
  z-index: 99;
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  /* background: #000; */
  .top-mask {
    position: absolute;
    z-index: 100;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    background: #000;
    color: #fff;
  }
}
.has-url {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 100;
}

.no-url {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 98;
  background: #303133;
  div.txt {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    color: #fff;
    font-size: 14px;
    width: 100%;
    text-align: center;
  }
  .prview-btn {
    display: inline-block;
  }
  .backAttr {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    img {
      width: 100%;
      height: 100%;
    }
    .back_txt {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 16px;
      /* line-height: 48px; */
      color: #fff;
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      height: 48px;
      background: rgba(0, 5, 32, 0.88);
    }
    .back_video_txt span {
      vertical-align: middle;
    }
    .back_video_txt i {
      margin-right: 10px;
      font-size: 20px;
      vertical-align: middle;
    }
  }
}
.control-play {
  z-index: 998;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  i {
    color: #fff;
    font-size: 80px;
  }
}
.video-control-bar {
  position: absolute;
  left: 0;
  bottom: 0;
  z-index: 100;
  width: 100%;
  height: 40px;
  background: rgba(0, 0, 0, 0.2);
  padding: 10px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  i {
    color: #fff;
    font-size: 16px;
    margin-left: 16px;
  }
}
</style>
